import React from 'react';
import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';
import Textbox from 'carbon-react/lib/components/textbox';
import { Option, Select } from 'carbon-react/lib/components/select';

import { useConsolidationContext } from '../../../../consolidation-context/consolidation-context';
import styles from './offset-eliminations-form.scss';

export const OffsetEliminationsForm = () => {
  const {
    eliminations: {
      eliminationsForm,
      coa: { categories }
    }
  } = useConsolidationContext();
  const intl = useIntl();

  return (
    <>
      <div className={styles.inputFieldContainer}>
        <Controller
          name="name"
          data-testid="OffsetEliminationsForm-name"
          control={eliminationsForm.control}
          rules={{
            required: intl.formatMessage({
              id: 'consolidation.please_enter_group_name',
              defaultMessage: 'Please enter a group name'
            })
          }}
          render={({ field }) => (
            <Textbox
              {...field}
              id="name"
              size="medium"
              error={
                eliminationsForm.formState.errors?.name ? eliminationsForm.formState.errors?.name?.message : undefined
              }
              maxLength={80}
              label={intl.formatMessage({
                id: 'consolidation.group_name',
                defaultMessage: 'Group name'
              })}
              placeholder={intl.formatMessage({
                id: 'consolidation.enter_elimination_group_name_here',
                defaultMessage: 'Enter the name of your offset elimination group here'
              })}
              autoComplete="off"
            />
          )}
        />
      </div>

      <div className={styles.inputFieldContainer}>
        <Controller
          name="category"
          control={eliminationsForm.control}
          rules={{
            required: intl.formatMessage({
              id: 'consolidation.please_choose_category',
              defaultMessage: 'Please choose category'
            })
          }}
          render={({ field }) => (
            <Select
              {...field}
              id="category"
              data-testid="OffsetEliminationsForm-category"
              autoComplete="off"
              size="medium"
              error={
                eliminationsForm.formState.errors?.category
                  ? eliminationsForm.formState.errors?.category?.message
                  : undefined
              }
              label={intl.formatMessage({
                id: 'consolidation.elimination_group_category',
                defaultMessage: 'Account category for elimination group'
              })}
            >
              {categories?.map(c => (
                <Option key={c.id} value={c.id} text={c.label} />
              ))}
            </Select>
          )}
        />
      </div>
    </>
  );
};
